import React from 'react';
import TextInput from './TextInput';

import Cleave from 'cleave.js/react';

/** @import {FormattedInputProps} from './FormattedInputTypes' */
/** @import {ChangeEvent} from 'cleave.js/react/props' */

/** @extends {TextInput<FormattedInputProps>} */
class FormattedInput extends TextInput {

  handleOnChange = (/** @type {ChangeEvent<HTMLInputElement>} */ e) => {
    const { onChangeRawValue } = this.props;

    // trigger TextInput's handleChange()
    this.handleChange(e);
    onChangeRawValue && onChangeRawValue(e.target.rawValue);
  }

  handleOnBlur = (/** @type {React.FocusEvent<HTMLInputElement, Element>} */ e) => {
    const {onBlur} = this.props;
    onBlur && onBlur(e);
  }

  renderLabel() {
    return this.props.label ? <label className='text-input__label'>{this.props.label}</label> : null;
  }

  render() {
    return (
      <div className='text-input-wrapper'>
        {this.renderLabel()}
        <Cleave
          name={this.props.name}
          placeholder={this.props.placeholder}
          options={this.props.options}
          className={this.getClassNames()}
          onChange={this.handleOnChange}
          onBlur={this.handleOnBlur}
          value={this.state.value}
          ref={this.props.setInputRef}
          disabled={this.props.disabled}
          type={this.props.type || 'text'}
          onKeyDown={this.props.onKeyDown}
        />
      </div>
    );
  }
}


export default FormattedInput;
